import SettingsView from "../settings/SettingsView";
import { useState, useCallback, useEffect, useMemo } from "react";
import Deployment from "../../services/deployment";
import Utils from "../../utils/utils";
import { useHasPermission } from "../../common/Hooks";
import { useParams } from "react-router-dom";
import LeftNavWithButtons from "../controls/LeftNavWithButtons";

const RuntimeConfigManagement = () => {
    const { id } = useParams();
    const [deployment, setDeployment] = useState({});
    const [settingsSetId, setSettingsSetId] = useState("");
    const configList = useMemo(() => {
        return [
            { _id: "App Settings" },
        ];
    }, []);

    const [selectedTab, setSelectedTab] = useState(configList[0]._id);

    const permissions = useHasPermission({
        domain: Utils.getDomain(),
        environment: deployment.environment ? deployment.environment._id : null,
        deployment: id,
        type: "deployment"
    });

    const getDeployment = useCallback(async (id) => {
        const response = await Deployment.getDeployment(id);
        if (!response.error) {
            setSettingsSetId(response.data.settingsSet);
            setDeployment(response.data);
        }
    }, []);

    useEffect(() => {
        if (id) {
            getDeployment(id);
        }
    }, [id, getDeployment]);

    const renderRightView = useMemo(() => {
        switch (selectedTab) {
            case "App Settings": {
                return <SettingsView
                    showCancel={false}
                    settingsSetId={settingsSetId}
                    permissions={permissions}
                    context={{ type: 'deployment', deploymentName: deployment.name, objectId: deployment._id }} />
            }
            default: {
                return <>{selectedTab}</>
            }
        }
    }, [deployment, permissions, selectedTab, settingsSetId]);

    return (
        <div className="h-100 row">
            <div className="col-2 col-xl-1 border-end p-0 px-3 d-block">
                <LeftNavWithButtons
                    listData={configList}
                    listAttr={"_id"}
                    listOnClick={(_id) => { setSelectedTab(_id); }}
                    selectedTab={selectedTab}
                />
            </div>
            <div className="col-10 col-xl-11 h-100 d-flex flex-column overflow-hidden">
                {renderRightView}
            </div>
        </div>
    )
}

export default RuntimeConfigManagement;